import {
    FETCH_ACTIVITIES_LIST,
    FETCH_ACTIVITIES_LIST_SUCCESS,
    FETCH_ACTIVITIES_LIST_FETCHING,
    FETCH_ACTIVITIES_LIST_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    payload: {},
    activitiesList: {},
    fetching: false,
    success: false,
    error: false
};

const fetchActivitiesListForTimeframeSuccess = (state, action) => {
    return {
        payload: action.activitiesListForTimeframe,
        activitiesList: {
            ...state.activitiesList,
            [action.displayName]: action.activitiesListForTimeframe
        },
        fetching: false,
        success: true,
        error: false
    };
};

const fetchActivitiesListForTimeframeFetching = (state, action) => {
    return { ...state, fetching: true };
};

const fetchActivitiesListForTimeframeFail = (state, action) => {
    return {
        payload: action.activitiesListForTimeframe,
        activitiesList: state.activitiesList,
        fetching: false,
        success: false,
        error: true
    };
};

const handlers = {
    [FETCH_ACTIVITIES_LIST_SUCCESS]: fetchActivitiesListForTimeframeSuccess,
    [FETCH_ACTIVITIES_LIST_FETCHING]: fetchActivitiesListForTimeframeFetching,
    [FETCH_ACTIVITIES_LIST_FAIL]: fetchActivitiesListForTimeframeFail
};

export default function activitiesListForTimeframe(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchActivitiesListForTimeframe(
    startTimestampLocal,
    endTimestampLocal,
    displayName,
    evictCache,
    activityTypeId,
    limit
) {
    return {
        type: FETCH_ACTIVITIES_LIST,
        displayName: displayName,
        startTimestampLocal: startTimestampLocal,
        endTimestampLocal: endTimestampLocal,
        activityTypeId: activityTypeId,
        limit: limit
    };
}

export const getActivitiesListForTimeframe = (state, displayName) => {
    return state.activitiesListForTimeframe.activitiesList[displayName]
        ? state.activitiesListForTimeframe.activitiesList[displayName]
        : [];
};

export const getActivitiesListForTimeframeStatus = (state) => {
    return {
        fetching: state.activitiesListForTimeframe.fetching,
        success: state.activitiesListForTimeframe.success,
        error: state.activitiesListForTimeframe.error
    };
};
